import React from 'react'

interface BlocksIconProps {
  size?: number
  selected?: boolean
}

const CreativesIcon: React.FC<BlocksIconProps> = ({ size = 36, selected = false }) => {
  const strokeColor = selected ? '#673BEC' : '#212121'

  return (
    <svg
      width={size}
      height={size * (35 / 36)} // maintain original aspect ratio
      viewBox="0 0 36 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.84869 27.8912H13.8887C14.684 27.8912 15.3287 27.2465 15.3287 26.4512V8.45093C15.3287 7.65564 14.684 7.01093 13.8887 7.01093H8.84869C8.05341 7.01093 7.40869 7.65564 7.40869 8.45093V26.4512C7.40869 27.2465 8.05341 27.8912 8.84869 27.8912Z"
        stroke={strokeColor}
        strokeWidth="2.16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8089 14.9312H26.8489C27.6442 14.9312 28.2889 14.2866 28.2889 13.4913V8.45093C28.2889 7.65564 27.6442 7.01093 26.8489 7.01093H21.8089C21.0136 7.01093 20.3689 7.65564 20.3689 8.45093V13.4913C20.3689 14.2866 21.0136 14.9312 21.8089 14.9312Z"
        stroke={strokeColor}
        strokeWidth="2.16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8089 27.8912H26.8489C27.6442 27.8912 28.2889 27.2465 28.2889 26.4512V21.4109C28.2889 20.6156 27.6442 19.9709 26.8489 19.9709H21.8089C21.0136 19.9709 20.3689 20.6156 20.3689 21.4109V26.4512C20.3689 27.2465 21.0136 27.8912 21.8089 27.8912Z"
        stroke={strokeColor}
        strokeWidth="2.16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CreativesIcon
